function HowItWorks() {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-2xl font-light text-gray-800 mb-4">How it works</h2>

      <div className="space-y-4 text-gray-600">
        <p>
          Wine quality varies significantly from year to year based on growing conditions.
          Weather events like frost, hailstorms, wildfires, and heat waves can dramatically
          affect grape quality and the resulting wine.
        </p>

        <p>
          OffVine helps you make informed decisions when purchasing wine by providing
          quick access to vintage quality information for major wine-producing regions.
        </p>

        <div className="bg-gray-50 rounded-lg p-4 mt-4">
          <h3 className="font-medium text-gray-800 mb-2">Quality Indicators</h3>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center">
              <span className="w-6 h-6 flex items-center justify-center bg-green-100 text-green-600 rounded-full mr-2">✓</span>
              <span><strong>Good conditions</strong> - Favorable weather, quality harvest</span>
            </li>
            <li className="flex items-center">
              <span className="w-6 h-6 flex items-center justify-center bg-yellow-100 text-yellow-600 rounded-full mr-2">~</span>
              <span><strong>Mixed results</strong> - Variable conditions, check specific wines</span>
            </li>
            <li className="flex items-center">
              <span className="w-6 h-6 flex items-center justify-center bg-red-100 text-red-600 rounded-full mr-2">✗</span>
              <span><strong>Challenging year</strong> - Adverse conditions affected quality</span>
            </li>
          </ul>
        </div>

        <p className="text-sm text-gray-500 mt-4">
          Use this as a general guide when shopping for wine. Keep in mind that
          individual producers may have exceptional wines even in challenging years.
        </p>
      </div>
    </div>
  )
}

export default HowItWorks
